import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type { CompanyStatement } from "./apiEcms.types";

const getCompanyStatement = (customerId: string, signal: AbortSignal) =>
  apiEcmsHttp.get<CompanyStatement>(`/companies/${customerId}/statement`, {
    signal,
  });

export const useGetCompanyStatement = (customerId: string) => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [QUERY_KEYS.TARIFF_SHIELDS_STATEMENT, customerId, currentGroup],
    queryFn: ({ signal }) => getCompanyStatement(customerId, signal),
    select: ({ data }) => ({
      certificate: data?.companyStatements[0]?.data,
      isShieldRejected: data?.companyStatements[0]?.customerRefusal,
    }),
  });
};
